import { render } from "./PastShiftsStatusButton.vue?vue&type=template&id=120c3efc"
import script from "./PastShiftsStatusButton.vue?vue&type=script&lang=js"
export * from "./PastShiftsStatusButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__